/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown> }} Notifications_Task_Assigned_BodyInputs */

const en_notifications_task_assigned_body = /** @type {(inputs: Notifications_Task_Assigned_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have been assigned a new task on case ${i?.caseNumber}.`)
};

const pt_br2_notifications_task_assigned_body = /** @type {(inputs: Notifications_Task_Assigned_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma nova atividade foi atribuída a você no caso ${i?.caseNumber}.`)
};

/**
* | output |
* | --- |
* | "You have been assigned a new task on case {caseNumber}." |
*
* @param {Notifications_Task_Assigned_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_assigned_body = /** @type {((inputs: Notifications_Task_Assigned_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Assigned_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_assigned_body(inputs)
	return pt_br2_notifications_task_assigned_body(inputs)
});